module.exports = __webpack_public_path__ + "static/media/Composer.3d973483.jpg";